import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * DEPRECATED — the backend now completes the audio-comics OAuth flow
 * server-side and redirects the browser directly to the requested next path
 * with the `ac_session_token` cookie already set. This route survives as a
 * safety net for stale bookmarks; it just forwards to the requested `next`
 * path or the audio-comics home.
 */
export default function AudioAuthCallback() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    const next = params.get("next") || "/audio-comics";
    const safe = next.startsWith("/") && !next.startsWith("//") ? next : "/audio-comics";
    nav(safe, { replace: true });
  }, [nav, params]);
  return (
    <div className="min-h-screen bg-[#0e0a14] text-white/60 flex items-center justify-center text-sm">
      Redirecting…
    </div>
  );
}
